module.exports = __webpack_public_path__ + "static/media/fractal-planet-3.13de8b70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/union-square/fractal-planet-3.jpg
// module id = 4471
// module chunks = 13